import { Block } from '@chameleoncreator/creator-app/build/utils';
import { createBlock } from './block';
import logo from 'assets/lizard.svg'; // lizard Logo_2019

export const createHeader = (): Block => {
  return createBlock('Header', [
    createBlock('Back'),
    createBlock('TopicTitle'),
    createBlock('Logo', [], { props: { src: logo } }),
    createBlock('Menu'),
  ]);
};
